/**
 * constants.js
 * design constants
 */


const constants = {};


constants.palette = {};


//#region misc
constants.palette.misc = {
  white: "hsl(205, 0%, 100%)",
  black: "hsl(205, 0%, 0)",

  // orthogonal test colours that don't normally appear in our palette to be used to highlight components they're set in
  testPurple: "hsl(300, 85%, 60%)",
  testGreen: "hsl(90, 36%, 50%)",
  testOrange: "hsl(20, 75%, 60%)",
};
//#endregion


//#region cool grey
constants.palette.coolGrey = {
  t25:    "hsl(218, 38%, 99%)",
  t50:    "hsl(216, 33%, 97%)",
  t100:   "hsl(214, 15%, 91%)",
  t150:   "hsl(212, 15%, 88%)",
  t200:   "hsl(210, 16%, 82%)",
  t300:   "hsl(211, 13%, 65%)",
  t400:   "hsl(211, 10%, 53%)",
  t500:   "hsl(211, 12%, 43%)",
  t600:   "hsl(209, 14%, 37%)",
  t700:   "hsl(209, 18%, 30%)",
  t800:   "hsl(209, 20%, 25%)",
  t900:   "hsl(210, 24%, 16%)",
};
//#endregion


//#region blue grey
constants.palette.blueGrey = {
  t25:    "hsl(210, 36%, 96%)",
  t50:    "hsl(212, 33%, 89%)",
  t100:   "hsl(210, 31%, 80%)",
  t200:   "hsl(211, 27%, 70%)",
  t300:   "hsl(209, 23%, 60%)",
  t400:   "hsl(210, 22%, 49%)",
  t500:   "hsl(209, 28%, 39%)",
  t550:   "hsl(209, 31%, 35%)",
  t600:   "hsl(209, 34%, 30%)",
  t650:   "hsl(210, 37%, 26%)",
  t700:   "hsl(211, 39%, 24%)",
  t750:   "hsl(210, 50%, 19%)",
  t800:   "hsl(209, 61%, 16%)",
  t900:   "hsl(210, 60%, 12%)",
  t1000:  "hsl(211, 49%, 8%)",
};
//#endregion


//#region brand blue
constants.palette.brandBlue = {
  t50:    "hsl(205, 60%, 97%)", 
  t100:   "hsl(205, 79%, 92%)",
  t200:   "hsl(205, 97%, 85%)",
  t300:   "hsl(205, 84%, 74%)",
  t400:   "hsl(205, 74%, 65%)",
  t500:   "hsl(205, 65%, 55%)",
  t600:   "hsl(205, 67%, 45%)",
  t700:   "hsl(205, 76%, 39%)",
  t800:   "hsl(205, 82%, 33%)",
  t900:   "hsl(205, 87%, 29%)",
  t1000:  "hsl(205, 100%, 21%)",
};
//#endregion


//#region brand orange
constants.palette.brandOrange = {
  t50:    "hsl(49, 100%, 96%)",
  t100:   "hsl(48, 100%, 88%)",
  t200:   "hsl(48, 95%, 76%)",
  t300:   "hsl(48, 94%, 68%)",
  t400:   "hsl(44, 92%, 63%)",
  t500:   "hsl(42, 87%, 55%)",
  t600:   "hsl(36, 77%, 49%)",
  t700:   "hsl(29, 80%, 44%)",
  t800:   "hsl(22, 82%, 39%)",
  t900:   "hsl(15, 86%, 30%)",
};
//#endregion


//#region brand puce
constants.palette.brandPuce = {
  t50:    "hsl(5, 29%, 95%)",
  t100:   "hsl(5, 29%, 90%)",
  t200:   "hsl(5, 29%, 80%)",
  t300:   "hsl(5, 29%, 70%)",
  t400:   "hsl(5, 29%, 60%)",
  t500:   "hsl(5, 29%, 54%)",
  t600:   "hsl(5, 29%, 45%)",
  t700:   "hsl(5, 29%, 35%)",
  t800:   "hsl(5, 29%, 25%)",
  t900:   "hsl(5, 29%, 15%)",
};
//#endregion


//#region success green
constants.palette.successGreen = {
  t50:    "hsl(152, 68%, 96%)",
  t100:   "hsl(154, 75%, 87%)",
  t200:   "hsl(156, 73%, 74%)",
  t300:   "hsl(158, 58%, 62%)",
  t400:   "hsl(160, 51%, 49%)",
  t500:   "hsl(162, 63%, 41%)",
  t600:   "hsl(164, 71%, 34%)",
  t700:   "hsl(166, 72%, 28%)",
  t800:   "hsl(168, 80%, 23%)",
  t900:   "hsl(170, 97%, 15%)",
  t950:   "hsl(170, 98%, 12%)",
};
//#endregion


//#region error red
constants.palette.errorRed = {
  t50:    "hsl(360, 100%, 97%)",
  t100:   "hsl(360, 82%, 89%)",
  t200:   "hsl(360, 77%, 78%)",
  t300:   "hsl(360, 71%, 66%)",
  t400:   "hsl(360, 64%, 55%)",
  t500:   "hsl(360, 67%, 44%)",
  t600:   "hsl(360, 72%, 38%)",
  t700:   "hsl(360, 79%, 32%)",
  t800:   "hsl(360, 85%, 25%)",
  t900:   "hsl(360, 92%, 20%)",
  t950:   "hsl(360, 96%, 15%)",
};
//#endregion


//#region warning orange
constants.palette.warning = {
  t50:    "hsl(22, 100%, 95%)",
  t100:   "hsl(22, 100%, 86%)",
  t200:   "hsl(22, 92%, 76%)",
  t300:   "hsl(21, 83%, 64%)",
  t400:   "hsl(22, 78%, 55%)",
  t500:   "hsl(22, 71%, 45%)",
  t600:   "hsl(22, 74%, 38%)",
  t700:   "hsl(22, 79%, 31%)",
  t800:   "hsl(22, 80%, 26%)",
  t900:   "hsl(22, 83%, 19%)",
};
//#endregion


export default constants;